/* eslint-disable @typescript-eslint/camelcase */
import { CreateManualDeductAddSaldoRequestInterface } from "../contracts/ManualDeductAddSaldoRequest";
import { toFormDataUtils } from "@/app/infrastructures/misc/Utils";

export class CreateDeductSaldoApiRequest
  implements CreateManualDeductAddSaldoRequestInterface {
  private actorType: string;
  private actorId: number;
  private adjustmentType: string;
  private amount: string;
  private notes: string;
  private proofFile: any;
  private currency: string;
  private token: string;
  private otp: string;
  private password: string;
  constructor(
    actorType: string,
    actorId: number,
    adjustmentType: string,
    amount: string,
    notes: string,
    proofFile: any,
    currency: string,
    token: string,
    otp: string,
    password: string
  ) {
    this.actorType = actorType;
    this.actorId = actorId;
    this.adjustmentType = adjustmentType;
    this.amount = amount;
    this.notes = notes;
    this.proofFile = proofFile;
    this.currency = currency;
    this.token = token;
    this.otp = otp;
    this.password = password;
  }

  public toFormData() {
    const data = {
      actor_type: this.actorType,
      actor_id: this.actorId,
      adjustment_type: this.adjustmentType,
      amount: this.amount,
      notes: this.notes,
      proof_file: this.proofFile,
      currency: this.currency,
      token: this.token,
      otp: this.otp,
      password: this.password
    };

    return toFormDataUtils(data);
  }
}
